module.exports = __webpack_public_path__ + "img/so.766acb2f.svg";